export default "/static/4179d214a5cfd3b3.png"